export default __webpack_public_path__ + "static/AdelleSans-Regular-eae04f4ae92aa59943ea92f925e0bf47.woff2";